import { getContrastingSpotSelectionColor } from '@glofoxinc/room-layout-map/interactiveSpotBooking';
import type { BranchColors } from './BookSpot.types';

const HEX_COLOR = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

function validHex(value: string | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return HEX_COLOR.test(trimmed) ? trimmed : null;
}

/**
 * One hex for the newly selected spot's border, tinted fill and label, derived from the
 * portal branding the same way the member app does for RNA-5254. Contrast math lives in
 * room-layout-map. Returns undefined when there is no usable branch colour so the map
 * keeps its default appearance.
 */
export function getSelectedSpotColor(
  branchColors: BranchColors | null | undefined
): string | undefined {
  const accent = validHex(branchColors?.accent);
  const background = validHex(branchColors?.background);
  const text = validHex(branchColors?.text);
  const hasUsableColor = [accent, background, text].some((color) => color !== null);
  if (!hasUsableColor) {
    return undefined;
  }
  return getContrastingSpotSelectionColor({
    accent: accent === null ? '' : accent,
    background: background === null ? '' : background,
    text: text === null ? '' : text
  });
}
